import c0 from './analytics_controller';
import c1 from './attachments_controller';
import c2 from './auto_submit_controller';
import c3 from './autocomplete_controller';
import c4 from './autocomplete_selection_controller';
import c5 from './bank_select_controller';
import c6 from './calendar_reservations_controller';
import c7 from './clear_zero_controller';
import c8 from './client_form_controller';
import c9 from './client_vehicle_modal_controller';
import c10 from './cookies_controller';
import c11 from './dashboard_calendar_controller';
import c12 from './date_picker_controller';
import c13 from './demo_spotlight_controller';
import c14 from './demo_tour_controller';
import c15 from './earnings_chart_controller';
import c16 from './filter_popover_controller';
import c17 from './global_search_controller';
import c18 from './html_editor_controller';
import c19 from './invitation_toggle_controller';
import c20 from './invoice_editor_controller';
import c21 from './limit_fields_controller';
import c22 from './loading_overlay_controller';
import c23 from './mark_read_controller';
import c24 from './navbar_scroll_controller';
import c25 from './parts_toggle_controller';
import c26 from './persistent_collapse_controller';
import c27 from './price_calculator_controller';
import c28 from './profile_controller';
import c29 from './public_registration_controller';
import c30 from './record_preview_controller';
import c31 from './remote_modal_controller';
import c32 from './replacement_vehicle_availability_controller';
import c33 from './reservation_time_controller';
import c34 from './row_link_controller';
import c35 from './sidebar_collapse_controller';
import c36 from './sidebar_drawer_controller';
import c37 from './single_submit_controller';
import c38 from './sortable_controller';
import c39 from './task_item_select_controller';
import c40 from './tooltip_controller';
import c41 from './unit_select_controller';
import c42 from './vehicle_category_fields_controller';
import c43 from './worksheet_form_controller';
import c44 from './worksheet_task_items_controller';
import c45 from './workspace_url_controller';
export const definitions = [
	{identifier: 'analytics', controllerConstructor: c0},
	{identifier: 'attachments', controllerConstructor: c1},
	{identifier: 'auto-submit', controllerConstructor: c2},
	{identifier: 'autocomplete', controllerConstructor: c3},
	{identifier: 'autocomplete-selection', controllerConstructor: c4},
	{identifier: 'bank-select', controllerConstructor: c5},
	{identifier: 'calendar-reservations', controllerConstructor: c6},
	{identifier: 'clear-zero', controllerConstructor: c7},
	{identifier: 'client-form', controllerConstructor: c8},
	{identifier: 'client-vehicle-modal', controllerConstructor: c9},
	{identifier: 'cookies', controllerConstructor: c10},
	{identifier: 'dashboard-calendar', controllerConstructor: c11},
	{identifier: 'date-picker', controllerConstructor: c12},
	{identifier: 'demo-spotlight', controllerConstructor: c13},
	{identifier: 'demo-tour', controllerConstructor: c14},
	{identifier: 'earnings-chart', controllerConstructor: c15},
	{identifier: 'filter-popover', controllerConstructor: c16},
	{identifier: 'global-search', controllerConstructor: c17},
	{identifier: 'html-editor', controllerConstructor: c18},
	{identifier: 'invitation-toggle', controllerConstructor: c19},
	{identifier: 'invoice-editor', controllerConstructor: c20},
	{identifier: 'limit-fields', controllerConstructor: c21},
	{identifier: 'loading-overlay', controllerConstructor: c22},
	{identifier: 'mark-read', controllerConstructor: c23},
	{identifier: 'navbar-scroll', controllerConstructor: c24},
	{identifier: 'parts-toggle', controllerConstructor: c25},
	{identifier: 'persistent-collapse', controllerConstructor: c26},
	{identifier: 'price-calculator', controllerConstructor: c27},
	{identifier: 'profile', controllerConstructor: c28},
	{identifier: 'public-registration', controllerConstructor: c29},
	{identifier: 'record-preview', controllerConstructor: c30},
	{identifier: 'remote-modal', controllerConstructor: c31},
	{identifier: 'replacement-vehicle-availability', controllerConstructor: c32},
	{identifier: 'reservation-time', controllerConstructor: c33},
	{identifier: 'row-link', controllerConstructor: c34},
	{identifier: 'sidebar-collapse', controllerConstructor: c35},
	{identifier: 'sidebar-drawer', controllerConstructor: c36},
	{identifier: 'single-submit', controllerConstructor: c37},
	{identifier: 'sortable', controllerConstructor: c38},
	{identifier: 'task-item-select', controllerConstructor: c39},
	{identifier: 'tooltip', controllerConstructor: c40},
	{identifier: 'unit-select', controllerConstructor: c41},
	{identifier: 'vehicle-category-fields', controllerConstructor: c42},
	{identifier: 'worksheet-form', controllerConstructor: c43},
	{identifier: 'worksheet-task-items', controllerConstructor: c44},
	{identifier: 'workspace-url', controllerConstructor: c45},
];
